module.exports = __webpack_public_path__ + "img/easybase-team.96b16a99.webp";